import { render, staticRenderFns } from "./getSsygList.vue?vue&type=template&id=6cce6c48&scoped=true&"
import script from "./getSsygList.vue?vue&type=script&lang=js&"
export * from "./getSsygList.vue?vue&type=script&lang=js&"
import style0 from "./getSsygList.vue?vue&type=style&index=0&id=6cce6c48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cce6c48",
  null
  
)

export default component.exports